import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import AceEditor from "react-ace";
import 'ace-builds/webpack-resolver';
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";


const QuestionProgramming = forwardRef((props, ref) => {

    const [template, setTemplate] = useState('');

    // useImperativeHandle is needed to be able to access isValid function from the parent component
    useImperativeHandle(ref, () => ({

        // Validator for exact answer
        isValid : () => {
            console.log(props.question)

            if (props.question.CodeLanguage && props.question.CodeLanguage != '')
                return {
                    valid: true,
                    message: null
                }
            else            
                return {
                    valid: false,
                    message: 'Please select the programming language'
                } 
        }
    }));

    useEffect(() => {
        //console.log(props.question)
        if (props.question.A_1) setTemplate(props.question.A_1);
    }, []); 
    
    
    const setLanguage = (e) => {
        let q = {...props.question};
        q.CodeLanguage = e.target.value;
        //props.setQuestion(q);

        // set code template
        let code;

        // c#
        if (e.target.value == 51) 
            code = `
using System;

public class Test
{
    public static void Main()
    {
        // your code goes here        
    }
}`;

        // c++
        if (e.target.value == 54) 
            code = `
#include <iostream>
using namespace std;

int main() {
    // your code goes here
    return 0;
}`;

        // java
        if (e.target.value == 91) 
            code = `
import java.util.*;
import java.lang.*;
import java.io.*;

class Test
{
    public static void main (String[] args) throws java.lang.Exception
    {
        // your code goes here
    }
}`;

        // javascript, php, typescript
        if (e.target.value == 97 || e.target.value == 98 || e.target.value == 101) 
            code = `// your code goes here`;            

        // python, ruby
        if (e.target.value == 71 || e.target.value == 72) 
            code =`# your code goes here`;            

        // perl
        if (e.target.value == 85) 
            code = `
#!/usr/bin/perl
# your code goes here`;            

        // vb.net
        if (e.target.value == 84) 
            code = `
Imports System

Public Class Test
    Public Shared Sub Main()
        ' your code goes here
    End Sub
End Class`;     

        // objective-c
        if (e.target.value == 79) 
            code =`
@implementation TestObj
int main()
{
// your code goes here
return 0;
}
@end`;

    setTemplate(code);
    //setCodeTemplate(code);
    q.A_1 = code;
    props.setQuestion(q);

    }

    const setCodeTemplate = (val) => {
        let q = {...props.question};
        q.A_1 = val;
        props.setQuestion(q)
        setTemplate(val); // preserve the template for setting the value in ace editor

    }

    // stdIn
    const setInput = (e) => { 
        let q = {...props.question};
        q.A_2 = e.target.value;
        props.setQuestion(q)

    }

    // stdOut
    const setOutput = (e) => {
        let q = {...props.question};
        q.A_3 = e.target.value;
        props.setQuestion(q)

    }


    return (
    < >
            <label htmlFor="title" className="w-1/5 mt-6 sm:mt-5 font-medium text-gray-700 ">
                Programming language
            </label>
            <div className="w-3/5 mt-6 sm:mt-5">
                <select defaultValue={props.question.CodeLanguage} onChange={(e) => setLanguage(e)} className='p-1 rounded-md w-full' required={true}>
                    <option value="">Select</option> 
                    <option value="51" >C# (Mono 6.6.0.161)</option>
                    <option value="54" >C++ (GCC 9.2.0)</option>
                    <option value="91" >Java (JDK 17.0.6)</option>
                    <option value="97" >Javascript (Node.js 20.17.0)</option>
                    <option value="79" >Objective-C (Clang 7.0.1)</option>
                    <option value="85" >Perl (5.28.1)</option>
                    <option value="98" >PHP (8.3.11)</option>
                    <option value="71" >Python (3.8.1)</option>
                    <option value="72" >Ruby (2.7.0)</option>
                    <option value="101" >Typescript (5.6.2)</option>
                    <option value="84" >VB.NET (vbnc 0.0.0.5943)</option>                
                </select>

            </div>
            <div className='w-1/5'></div>


            <label className="w-1/5 mt-6 sm:mt-5 font-medium text-gray-700 ">Code template</label>   
            <div className="w-3/5 mt-6 sm:mt-5">         
            <AceEditor
                width={ '100%' }
                mode="javascript"
                theme="github"
                onChange={val=> {setCodeTemplate(val)}}
                fontSize={14}
                showPrintMargin={true}
                showGutter={true}
                highlightActiveLine={true}          
                value={template}     
                setOptions={{
                    useWorker: false,
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    showLineNumbers: true,
                    tabSize: 2,
                }}
            />
            </div>
            <div className='w-1/5'></div>


            <label htmlFor="title" className="w-1/5 mt-6 sm:mt-5 font-medium text-gray-700 ">
                Standard input
            </label>
            <div className="w-3/5 mt-6 sm:mt-5">
                <span className='text-gray-500'>(if applicable)</span>
                <textarea value={props.question.A_2 ? props.question.A_2 : ""} onChange={e=> {setInput(e)}} className='w-full h-40  rounded'></textarea>
            </div>
            <div className='w-1/5'></div>

            <label htmlFor="title" className="w-1/5 mt-6 sm:mt-5 font-medium text-gray-700 ">
                Expected output
            </label>
            <div className="w-3/5 mt-6 sm:mt-5">
                <span className='text-gray-500'>(if applicable, will be used to verify the solution and will not be displayed to candidates)</span>
                <textarea value={props.question.A_3 ? props.question.A_3 : ""} onChange={e=> {setOutput(e)}} className='w-full h-40 bo rounded'></textarea>
            </div>
            <div className='w-1/5'></div>

    </>
    );
});

export default QuestionProgramming;